import moment from 'moment';
import React from 'react';
import { IFuncionario } from '../../../../@interfaces';

import { Container, NameContainer, UserContainer, Avatar } from './styles';

interface IProps {
  funcionario: IFuncionario
}

const Card: React.FC<IProps> = ({ funcionario }) => {
  const dtAdmissao = moment(funcionario.dtAdmissao?.replace('Z', "")).format('DD/MM/YYYY')
  return (
    <Container>
      <UserContainer>
        <Avatar>
          {<img src={funcionario.avatar ? funcionario.avatar : "assets/user.png"} />}
        </Avatar>
        <NameContainer>
          <span>{funcionario.nome}</span>
          <span id={'empresa'}>{funcionario.empresa}</span>
        </NameContainer>
      </UserContainer>
      <span id="admissao">Data de admissão: <span id='admissaoValue'>{dtAdmissao}</span></span>
    </Container>
  )
}

export default Card;